window.evdnceApplySwatchVisibility = function(g) {
  var gender = g || sessionStorage.getItem('evdnce_gender');

  // PDP colour swatches (evp-swatch)
  document.querySelectorAll('.evp-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.getAttribute('data-has-women') === 'true') {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // PLP + PDP card swatches (evdnce-card-swatch)
  document.querySelectorAll('.evdnce-card-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.hasAttribute('data-image-women')) {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // Hide men-only cards in women's context, women-only in men's
  document.querySelectorAll('product-card[data-product-gender]').forEach(function(card) {
    var pg = card.getAttribute('data-product-gender');
    if (gender === 'women' && pg === 'men') {
      card.closest('.swiper-slide') ? card.closest('.swiper-slide').style.display = 'none' : card.style.display = 'none';
    } else if (gender === 'men' && pg === 'women') {
      card.closest('.swiper-slide') ? card.closest('.swiper-slide').style.display = 'none' : card.style.display = 'none';
    } else {
      card.closest('.swiper-slide') ? card.closest('.swiper-slide').style.display = '' : card.style.display = '';
    }
  });

  // Update all swipers after hiding slides
  setTimeout(function() {
    document.querySelectorAll('.swiper').forEach(function(el) {
      if (el.swiper) {
        el.swiper.update();
      }
    });
  }, 50);
};

// Run on load
(function() {
  function init() {
    if (typeof window.evdnceApplySwatchVisibility === 'function') {
      window.evdnceApplySwatchVisibility();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
